import React from 'react';

/**
 * 아티클의 날짜·작성자·카테고리·키워드를 같은 위계로 나열하는 태그.
 *
 * <p>BaseButton을 쓰면 안 된다:
 * 1) size별 min-width(s = 57px) + justify-center가 강제돼 짧은 태그가 헐렁해진다
 * 2) BaseButton 내부 타이포가 텍스트의 한글 여부로 en/kr 토큰을 자동 전환해서,
 *    한글 태그만 weight 500이 되고 영문·숫자 태그는 400으로 남는다
 * 3) 카드 전체가 role="button"이라 그 안에 button을 넣으면 중첩 인터랙티브가 된다
 */
const MetaTag = ({ children }) => (
  <span className='inline-flex shrink-0 items-center rounded-[6px] bg-grayscale-gray01 px-2 py-1 text-[12px] font-normal leading-[1.4] text-text-placeholder'>
    {children}
  </span>
);

/** 아티클에서 메타 태그로 쓸 값들을 순서대로 뽑는다 (빈 값 제거) */
export const buildMetaTags = (article, formattedDate) =>
  [
    formattedDate,
    ...(article?.authors ?? []),
    ...(article?.category ? [article.category] : []),
    ...(article?.keywords ?? []),
  ].filter(Boolean);

export default MetaTag;
